import { render, staticRenderFns } from "./SimpleSkill.vue?vue&type=template&id=32f54d06&scoped=true"
import script from "./SimpleSkill.vue?vue&type=script&lang=js"
export * from "./SimpleSkill.vue?vue&type=script&lang=js"
import style0 from "./SimpleSkill.vue?vue&type=style&index=0&id=32f54d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f54d06",
  null
  
)

export default component.exports